import { api } from '@/lib/api/client';
import type { ActiveLog, ActiveLogFilter } from './types';

export interface ActiveLogListParams {
  filter?: ActiveLogFilter;
  page?: number;
  perPage?: number;
  sort?: string;
  order?: 'ASC' | 'DESC';
}

export const activeLogApi = {
  list: (params: ActiveLogListParams = {}) =>
    api.list<ActiveLog>('/active-log', {
      page: params.page,
      perPage: params.perPage,
      sort: params.sort ?? 'createdAt',
      order: params.order ?? 'DESC',
      filter: params.filter as Record<string, unknown> | undefined,
    }),

  get: (id: number) => api.get<ActiveLog>(`/active-log/${id}`),
};
